// Contact.jsx
import React, { useState } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Contact = () => {

  const [name, setName] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const phoneNumber = "+919173731220"; // Replace with your WhatsApp number

  const handleSubmit = (e) => {
    e.preventDefault();
    const encodedMessage = encodeURIComponent(`Hello, my name is ${name}. Subject: ${subject}. Message: ${message}`);
    const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(url, '_blank');
  };


  return (
    <section id="contact" className="py-20 bg-green-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-20 text-center">
          <span className="text-xl font-bold ">Contact </span>
          <span className="text-xl font-bold text-green-600">Us</span>
        </div>
        <div className="grid md:grid-cols-2 gap-10 md:gap-20 mb-4">
          <div className='bg-white p-8 rounded-lg shadow-lg'>
            <h3 className="text-xl font-semibold mb-6 text-gray-800">Get in Touch</h3>
            <div className="space-y-4">
              <div className="flex items-center">
                <Phone className="w-6 h-6 text-green-600 mr-4" />
                <span className="text-gray-600 text-sm md:text-lg">
                  <a href={`tel:+919173731220`} style={{ textDecoration: "none" }}>
                    +91 91737 31220
                  </a>
                </span>
              </div>
              <div className="flex items-center">
                <Mail className="w-6 h-6 text-green-600 mr-4" />
                <span className="text-gray-600 text-sm md:text-lg">
                  <a href="mailto:tanmay@evergreenpartners.in" style={{ textDecoration: "none" }}>
                    tanmay@evergreenpartners.in
                  </a>
                </span>
              </div>
              <div className="flex items-center">
                <MapPin style={{ width: '3rem', height: '3rem' }} className="h-6 w-6 text-green-600 mr-4" />
                <div className="text-gray-600 text-sm md:text-lg">507 International Wealth Center, Near Luthra Circle, VIP Road, Vesu, Surat - 395007</div>
              </div>
            </div>
          </div>
          <div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29770.19523732595!2d72.7487416791016!3d21.14147530000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04db21e9563f5%3A0x6e59745b99d8486c!2sEvergreen%20Growth%20Partners%20-%20Investment%20Banking%2C%20IPO%20Advisory%2C%20Wealth%20Management%2C%20Mutual%20Funds%2C%20SIP%2C%20Pre%20IPO%2C%20AIF%2C%20PMS!5e0!3m2!1sen!2sin!4v1773322167250!5m2!1sen!2sin" width="100%" height="270vh" style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
        <div className='bg-white p-8 rounded-lg shadow-lg text-sm'>
          <h3 className="text-xl font-semibold mb-6 text-gray-800">Send a Message</h3>
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div>
              <input
                type="text"
                placeholder="Subject"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>
            <div>
              <textarea
                placeholder="Your Message"
                rows={4}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition duration-300"
            >
              Send Message
            </button>
          </form>
        </div>


      </div>
    </section>
  );
};